import React from 'react';
import { NoConsentDashboard } from '../../components/dashboards/noconsent-outbrain/NoConsentDashboard';

export const NoConsentDashboardPage: React.FC = () => {
  return <NoConsentDashboard />;
};